import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Modal } from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";

const AddDetailsModal = ({ show, onHide, onSave }) => {
  const [contestedDate, setContestedDate] = useState(null);
  const [comment, setComment] = useState("");
  const [attachmentFiles, setAttachmentFiles] = useState([]);
  const attachmentInputRef = useRef(null);

  useEffect(() => {
    if (!show) {
      setContestedDate(null);
      setComment("");
      setAttachmentFiles([]);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} className="modalWidth">
      <Modal.Header closeButton className="customModal">
        <Modal.Title className="mx-auto">Assign Contested Case</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          {/* Contested Date */}
          <div className="row mb-3 align-items-center">
            <div className="col-md-3">
              <label className="form-label">Contested Date <span className="text-danger">*</span></label>
            </div>
            <div className="col-md-9">
              <DatePicker
                selected={contestedDate}
                onChange={(date) => setContestedDate(date)}
                minDate={new Date()}
                placeholderText="Select contested date"
                dateFormat="MM/dd/yyyy"
                className="form-control date-picker-sm"
              />
            </div>
          </div>

          {/* Attachment upload */}
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="form-group flex-container">
                <label className="form-label">Upload Attachment (PDF / Image)</label>
                <IoMdAdd className="fs-4 cstmIcon" onClick={() => attachmentInputRef.current.click()} />
                <input
                  type="file"
                  ref={attachmentInputRef}
                  accept="application/pdf,image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => setAttachmentFiles((prev) => [...prev, ...Array.from(e.target.files)])}
                />
              </div>
              {attachmentFiles.length > 0 && (
                <div className="file-list mt-1">
                  <ul>
                    {attachmentFiles.map((file, index) => (
                      <li key={index} className="file-item">
                        <span>{file.name}</span>
                        <button
                          type="button"
                          onClick={() => setAttachmentFiles((prev) => prev.filter((_, i) => i !== index))}
                          className="remove-button"
                        >
                          <MdDeleteForever className="fs-4" />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Comments */}
          <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">Comments</label>
              <textarea
                rows="3"
                className="form-control"
                placeholder="Enter comments..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="mx-auto d-flex justify-content-center">
        <Button
          onClick={() => onSave({ isContested: true, contestedDate, comment, attachmentFiles })}
          className="custBtn"
          disabled={!contestedDate}
        >
          Save Changes
        </Button>
        <Button onClick={onHide} className="custBtn">Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddDetailsModal;
